import React, { useCallback, useRef } from "react";
import { Link as RouterLink, useHistory, useLocation } from "react-router-dom";
import { Link } from "@material-ui/core";
import LaunchIcon from "@material-ui/icons/Launch";
import Url from "url-parse";
import { useEnv } from "../plugins/env";
import { getBasename } from "../utils/helpers";

// 1. Strip `navigate` from props to prevent error
// 2. Preserve stack param

export default React.forwardRef((props, ref) => {
  const {
    navigate,
    path,
    newTab,
    absolutePath = false,
    samePage,
    ...rest
  } = props;
  const { stack, defaultStack } = useEnv();

  const url = new Url(path, {}, true);
  if (stack !== defaultStack) {
    url.query.stack = stack;
  }

  if (samePage) {
    const href = absolutePath ? path : url.toString();
 
    return (
      <Link ref={ref} href={href}>
        {rest.children}
      </Link>
    );
  } else {
    if (!newTab) {
      return (
        <Link ref={ref} component={RouterLink} to={url.toString()} {...rest}>
          {rest.children}
        </Link>
      );
    } else {
      const href = absolutePath ? path : url.toString();
      // : cleanDuplicateSlash(getBasename() + url.toString());
      return (
        <Link ref={ref} target="_blank" href={href}>
          {rest.children}
          &nbsp;
          <LaunchIcon fontSize="small" style={{ verticalAlign: "middle" }} />
        </Link>
      );
    }
  }
});

export function usePushHistory() {
  const history = useHistory();
  const { stack, defaultStack } = useEnv();
  const isPushingRef = useRef(false);

  let location = useLocation();

  const pushHistory = useCallback(
    (path) => {
      if (isPushingRef.current) return;
      isPushingRef.current = true;

      const url = new Url(path, {}, true);
      if (stack !== defaultStack) {
        url.query.stack = stack;
      }
      history.push(url.toString());

      setTimeout(() => {
        isPushingRef.current = false;
      }, 300); // Debounce duration
    },
    [history, stack, defaultStack]
  );

  return pushHistory;
}

export function useReplaceHistory() {
  const history = useHistory();
  const { stack, defaultStack } = useEnv();
  const isReplacingRef = useRef(false);

  let location = useLocation();

  const replaceHistory = useCallback(
    (path) => {
      if (isReplacingRef.current) return;
      isReplacingRef.current = true;

      const url = new Url(path, {}, true);
      if (stack !== defaultStack) {
        url.query.stack = stack;
      }
      history.replace(url.toString());

      setTimeout(() => {
        isReplacingRef.current = false;
      }, 300); // Debounce duration
    },
    [history, stack, defaultStack]
  );

  return replaceHistory;
}
